const styles = theme => ({
  organizationsContainer: {
    width: "calc(100% - 100px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  organizationContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderBottom: "1px #CCCCCC solid"
  },
  organizationTitle: {
    color: theme.palette.primary.default,
    marginTop: theme.spacing(6)
  },
  noConnectedImg: {
    marginBottom: theme.spacing(2)
  },
  leftOrganizationContainer: {
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(1)
    }
  },
  avatarContainer: {
    marginRight: theme.spacing(2)
  },
  rightOrganizationContainer: {
    width: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      justifyContent: "center"
    }
  },

  name: {
    color: "#78A1BB"
  },
  address: {
    fontWeight: "normal !important",
    color: theme.palette.primary.default
  },
  connectedRequestedText: {
    marginLeft: theme.spacing(1)
  },
  acceptButton: {
    marginLeft: theme.spacing(4)
  },
  disconnectButton: {
    marginLeft: theme.spacing(2),
    color: [theme.palette.warning.main, "!important"]
  },
  disconnectButtonWorking: {
    marginLeft: theme.spacing(2),

    color: [theme.palette.secondary.main, "!important"],
    opacity: 0.3
  },
  buttonProgress: {
    margin: "0 auto",
    marginTop: "-10%"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/ConnectedOrganizations/styles.js